import React from 'react';
import PropTypes from 'prop-types';

// Edge does not support object-fit, simulate with background image if needed.

function ObjectFitImg(props) {
  if (window.igglo.supportsObjectFit) {
    const { fit, ...rest } = props;

    return (<img {...rest} style={{ objectFit: fit }} />);
  }

  const { fit, src, ...rest } = props;

  return (
    <div
      style={{
        backgroundImage: `url('${src}')`,
        backgroundSize: fit,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
      {...rest}
    />
  );
}

ObjectFitImg.propTypes = {
  fit: PropTypes.oneOf(['contain', 'cover']).isRequired,
  src: PropTypes.string.isRequired
};

export default ObjectFitImg;
